import React from 'react';
import { ActiveTab } from './utils/types';

interface SearchFiltersProps {
  activeTab: ActiveTab;
  searchTerm: string;
  dateSearch: string;
  onSearchTermChange: (value: string) => void;
  onDateSearchChange: (value: string) => void;
  onSearch: () => void;
  onReset: () => void;
}

const SearchFilters: React.FC<SearchFiltersProps> = ({
  activeTab,
  searchTerm,
  dateSearch,
  onSearchTermChange,
  onDateSearchChange,
  onSearch,
  onReset
}) => {
  const getPlaceholder = () => {
    switch (activeTab) {
      case 'documents':
        return "Référence, nom, email, profession, pays...";
      case 'transferts':
        return "Référence, nom, email, type transfert...";
      case 'users':
        return "Nom d'utilisateur, email...";
      default:
        return "Rechercher...";
    }
  };

  return (
    <div className="bg-white rounded-lg p-4 sm:p-6 mb-6 sm:mb-8 shadow-sm border hover:shadow-lg transition-shadow duration-300">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
        <div className="flex-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Rechercher {activeTab === 'documents' ? 'un document' : activeTab === 'transferts' ? 'un transfert' : 'un utilisateur'}
          </label>
          <input
            type="text"
            placeholder={getPlaceholder()}
            value={searchTerm}
            onChange={(e) => onSearchTermChange(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && onSearch()}
            className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        {(activeTab === 'documents' || activeTab === 'transferts') && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Recherche par date
            </label>
            <input
              type="date"
              value={dateSearch}
              onChange={(e) => onDateSearchChange(e.target.value)}
              className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
        )}

        <div className="flex space-x-2">
          <button
            onClick={onSearch}
            className="px-4 sm:px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 hover:shadow-lg transition-all duration-300 flex items-center"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            Rechercher
          </button>
          <button
            onClick={onReset}
            className="px-3 sm:px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 hover:shadow-lg transition-all duration-300"
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchFilters;
